module.exports = __webpack_public_path__ + "img/37_5.f692e933.png";